import store from '../store';

export default function registered({ next, router }) {
  if(store.getters.isAuthenticated) {
    if(store.getters['profile/user'].email_verified_at == null) {
      return next();
    }

    return router.push({ path: '/home' });
  }

  return next();
}